(() => {
  const KEY = 'studioos-recently-viewed-v1';
  const LIMIT = 12;
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };
  const write = (items) => localStorage.setItem(KEY, JSON.stringify(items.slice(0, LIMIT)));
  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
  }[character]));

  const capture = () => {
    const node = document.querySelector('[data-recent-product]');
    if (!node) return;
    const item = {
      handle: node.dataset.productHandle || '',
      title: node.dataset.productTitle || '',
      url: node.dataset.productUrl || '',
      image: node.dataset.productImage || '',
      price: node.dataset.productPrice || '',
      vendor: node.dataset.productVendor || '',
      variantId: node.dataset.productVariantId || ''
    };
    if (!item.handle) return;
    write([item, ...read().filter((entry) => entry.handle !== item.handle)]);
  };

  const card = (item) => `
    <article class="studioos-featured-card">
      <a class="studioos-featured-card__media" href="${escapeHTML(item.url)}">
        ${item.image ? `<img class="studioos-featured-card__image" src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : ''}
      </a>
      <div class="studioos-featured-card__content">
        ${item.vendor ? `<p class="studioos-featured-card__vendor">${escapeHTML(item.vendor)}</p>` : ''}
        <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
        <div class="studioos-featured-card__price"><strong>${escapeHTML(item.price)}</strong></div>
        ${item.variantId
          ? `<button type="button" class="studioos-featured-card__button" data-recent-add="${escapeHTML(item.variantId)}">Quick add</button>`
          : `<a class="studioos-featured-card__button" href="${escapeHTML(item.url)}">View product</a>`}
      </div>
    </article>`;

  const setupDrag = (section, rail) => {
    if (rail.dataset.recentDragReady === 'true') return;
    rail.dataset.recentDragReady = 'true';
    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let distance = 0;
    let suppressNextClick = false;

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('button,input,select,textarea')) return;
      dragging = true;
      distance = 0;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      distance = Math.max(distance, Math.abs(delta));
      if (distance < 8) return;
      rail.classList.add('is-dragging');
      rail.scrollLeft = startScroll - delta;
      event.preventDefault();
    });

    const stopDrag = () => {
      if (!dragging) return;
      dragging = false;
      rail.classList.remove('is-dragging');
      if (distance >= 8) {
        suppressNextClick = true;
        window.setTimeout(() => { suppressNextClick = false; }, 120);
      }
    };
    rail.addEventListener('pointerup', stopDrag);
    rail.addEventListener('pointercancel', stopDrag);
    rail.addEventListener('pointerleave', stopDrag);
    rail.addEventListener('click', (event) => {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressNextClick = false;
    }, true);
  };

  const render = () => {
    document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
      const rail = section.querySelector('[data-recent-rail]');
      if (!rail) return;
      const current = document.querySelector('[data-recent-product]')?.dataset.productHandle;
      const items = read().filter((item) => item.handle !== current);
      section.hidden = items.length === 0;
      rail.innerHTML = items.map(card).join('');
      setupDrag(section, rail);
    });
  };

  document.addEventListener('click', async (event) => {
    const section = event.target.closest('[data-recently-viewed]');
    if (!section) return;
    const rail = section.querySelector('[data-recent-rail]');
    const cardWidth = rail?.querySelector('.studioos-featured-card')?.getBoundingClientRect().width || 304;
    const step = cardWidth + 16;

    if (event.target.closest('[data-recent-prev]')) {
      rail?.scrollBy({ left: -step, behavior: 'smooth' });
      return;
    }
    if (event.target.closest('[data-recent-next]')) {
      rail?.scrollBy({ left: step, behavior: 'smooth' });
      return;
    }
    if (event.target.closest('[data-recent-clear]')) {
      write([]);
      render();
      return;
    }

    // Add-to-cart is handled centrally by ez-theme.js.
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { capture(); render(); }, { once: true });
  } else {
    capture();
    render();
  }
  window.addEventListener('storage', render);
  document.addEventListener('shopify:section:load', render);
})();
